import { render, staticRenderFns } from "./TermsOfUseList.vue?vue&type=template&id=3416c386&"
import script from "./TermsOfUseList.vue?vue&type=script&lang=js&"
export * from "./TermsOfUseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports